
const initialState = {
    isFetching: false,
    errorMessage: null,
}

export default initialState;